import {
    Component, OnInit, Input, TemplateRef,
    ViewChild, OnChanges, SimpleChanges, SimpleChange
} from '@angular/core';
import { EpToastService, IEpTreeViewModel, EpButtonSize, EpGridComponent, IEpGridModel, IEpGridSelectionOptions, EpGridEvent, EpButtonStyle, IEpComponentEventArg } from '@epicor/kinetic';
import {
    FieldAgentClient, ObjectAttachmentFolder, GetSubFoldersForObjectFolderRequest,
    ObjectAttachmentFolderListType, ObjectAttachmentFolderSubFolderFormat, Attachment,
    SaveObjectAttachmentRequest, AttachmentSubFolderFormat, Kind,
    GetSubFoldersForDocumentFolderRequest, DocumentAttachmentFolderListType,
    DocumentAttachmentFolderSubFolderFormat, DocumentAttachmentFolder,
    SaveDocumentAttachmentRequest, GetObjectAttachmentDataRequest, GetDocumentAttachmentDataRequest
} from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { BistrackConfig, CustomEvents, ErrorStatus, DocumentListType } from 'ep-bt-controls';
import { FileInfo, FileState } from '@progress/kendo-angular-upload';
import { EpEventService } from '@epicor/kinetic';
import { EpDialogService, EpDialogSize } from '@epicor/kinetic';
import { EpbtFaImageDialogComponent } from '../../dialogs/epbt-fa-image-dialog/epbt-fa-image-dialog.component';
import { EpbtFaAttachmentModel } from './epbt-fa-attachment-tree.model';
import { EpbtFaContactsService } from '../../services/epbt-fa-contacts.service';


const is = (fileName: string, ext: string) => new RegExp(`.${ext}\$`).test(fileName);

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'epbt-fa-attachment',
    templateUrl: './epbt-fa-attachment.component.html',
    styleUrls: ['./epbt-fa-attachment.component.scss']
})
export class EpbtFaAttachmentComponent implements OnChanges, OnInit {
    EpButtonStyle = EpButtonStyle;

    public treeNodes: EpbtFaAttachmentModel[] = [];

    @Input() customerId: number;
    @Input() objectListType: ObjectAttachmentFolderListType;
    @Input() documentListType: DocumentAttachmentFolderListType;
    @Input() baseFolderName: string;
    @Input() type: string;
    @Input() sourceId: number;
    @Input() sourceItemCode: string;
    @Input() displayPanel: boolean;
    @Input() isEditable = true;
    @Input() signatureType: number;

    // Page name is mainly for contacts and opportunity
    @Input() pageName;
    // This property is only for Quick order/quote
    @Input() selectedTransactionType;
    // Tree view code start
    public selectedKeys: any[] = ['0_10'];
    public expandedKeys: any[] = [];
    public selected: '';
    epTreeView: IEpTreeViewModel;
    codeString = '';
    gridModel: IEpGridModel;
    // public hasChildren = (item: any) => item.subFolders && item.subFolders.length > 0;

    // Tree view code end

    // File Upload code start
    uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
    uploadRemoveUrl = 'removeUrl';
    myFiles: Array<FileInfo> = [];
    EpButtonSize = EpButtonSize;
    attachmentFile: any;
    attachmentData: any;
    imageData: string;
    validate = true;
    specialMessage = true;
    // File Upload code end

    indexArray: any[] = [];
    public selectedItem: any;
    public objectFolders: ObjectAttachmentFolder[] = [];
    public documentFolders: DocumentAttachmentFolder[] = [];
    public allAttachments: any[] = [];
    webTrackUser: any;
    flag = false;
    displayGrid = false;
    disableUpload = false;
    showAttachPanel = false;
    showSignPanel = false;
    attachmentProperties = {
        fileName: '',
        attachmentName: '',
        description: '',
        category: ''
    };

    signOptions = {
        'canvasHeight': 200,
        'canvasWidth': 800,
        'backgroundColor': 'lightgray',
        'penColor': 'gray',
        'showSavePngButton': false,
        'showSaveJpgButton': false,
        'showClearButton': true,
        'showAcceptButton': true,
        'value': '',
        'signatureClear': false
    };

    @ViewChild('attachDownloadTemplate', { static: true }) attachDownloadTemplate: TemplateRef<any>;
    @ViewChild('attachDeleteTemplate', { static: true }) attachDeleteTemplate: TemplateRef<any>;

    constructor(public epToast: EpToastService, private client: FieldAgentClient,
        private faService: EpbtFieldAgentService, private config: BistrackConfig, public epEvent: EpEventService,
        private contactService: EpbtFaContactsService) { }

    ngOnChanges(changes: SimpleChanges) {
        if (this.pageName == 'QuickOrderAttachment') {
            const sourceId: SimpleChange = changes.sourceId;
            const sourceItemCode: SimpleChange = changes.sourceItemCode;
            const selectedTransactionType: SimpleChange = changes.selectedTransactionType;
            if (sourceId) {
                this.sourceId = sourceId.currentValue;
            }
            if (sourceItemCode) {
                this.sourceItemCode = sourceItemCode.currentValue;
            }
            if (selectedTransactionType) {
                this.selectedTransactionType = selectedTransactionType.currentValue;
                this.baseFolderName = this.selectedTransactionType == 1 ? 'Sales Orders' : 'Quotes';
                this.documentListType = this.selectedTransactionType == 1 ? DocumentAttachmentFolderListType.SalesOrder : DocumentAttachmentFolderListType.Quote;
                this.signatureType = this.selectedTransactionType == 1 ? DocumentListType.SalesOrder : DocumentListType.Quote;
                this.faService.getWebTrackUser((webTrackUser: any) => {
                    this.treeNodes = [].slice();
                    this.webTrackUser = webTrackUser;
                    this.customerId = this.customerId ? this.customerId : -1;
                    this.getSubFolderData(this.getBaseFolderRequest(), (result: any) => {
                        // console.log(result);
                    });
                    this.getTreeModel();
                });
            }
        }
    }

    ngOnInit() {
        this.faService.getWebTrackUser((webTrackUser: any) => {
            this.webTrackUser = webTrackUser;
            this.customerId = this.customerId ? this.customerId : -1;
            this.getSubFolderData(this.getBaseFolderRequest(), (result: any) => {
                console.log(result);
            });
            this.getTreeModel();
            this.getAllAttachments(this.sourceId);
        });
    }

    // Tree code start

    getTreeModel() {
        this.epTreeView = {
            // name: 'EpTreeView',
            nodes: this.treeNodes,
            // textField: 'Name',
            // childrenField: 'AttachmentOrFolderModel',
            // selectedKeys: this.selectedKeys,
            // disabledKeys: [],
            // epTreeViewSelectable: { mode: 'single' },
            // expandedKeys: this.expandedKeys,
            // navigable: true,
            // //hasChildren: this.hasChildren,
            // epOnSelectionChange: (eventArg) => { this.selectionChange(eventArg.event); },
            // epOnCollapse: (eventArg) => { this.collapse(eventArg.event); },
            // epOnExpand: (eventArg) => { this.expand(eventArg.event); },
            // epOnSelectedKeysChange: (eventArg) => { this.SelectedKeysChange(eventArg.event); },
            // epOnExpandedKeysChange: (eventArg) => { this.ExpandedKeysChange(eventArg.event); }
        };
    }

    expand(event: any) {
    }

    collapse(event: any) {
        console.log('Collapse');
        console.log(event.dataItem);
    }

    selectionChange(event: any) {
        this.imageData = '';
        if (event.dataItem.Type == 'Attachment') {
            this.getAttachmentDataForFolderSpecific(event.dataItem.Attachment);
        } else {
            this.getTreeIndex(event.index);
            this.selected = event.dataItem.Name;
            this.selectedItem = event.dataItem;
            this.getSubFolderData(this.getSubFolderRequest(event.dataItem), (result: any) => {
                console.log(result);
            });
        }
    }

    SelectedKeysChange(event: any) {
        this.selectedKeys = this.epTreeView.selectedKeys;
        console.log(this.selectedKeys);
    }

    ExpandedKeysChange(event: any) {
        this.expandedKeys = this.epTreeView.expandedKeys;
    }

    getTreeIndex(index: any) {
        this.indexArray = index.split('_');
    }

    // Tree code end

    // Request methods start

    getBaseFolderRequest(): any {
        let request: any;
        if (this.type == Kind.Object) {
            request = new GetSubFoldersForObjectFolderRequest();
            request.currentUser = this.webTrackUser;
            request.currentUser.customer.customerId = this.customerId;
            request.folder = new ObjectAttachmentFolder();
            request.folder.listType = this.objectListType;
            request.folder.baseFolderName = this.baseFolderName;
            request.folder.folderID = 0;
            request.folder.parentFolderID = 0;
            request.folder.description = 'All';
            request.folder.location = '';
            request.folder.subFolderFormat = ObjectAttachmentFolderSubFolderFormat.None;
            return request;
        } else if (this.type == Kind.Document) {
            request = new GetSubFoldersForDocumentFolderRequest();
            request.user = this.webTrackUser;
            request.user.customer.customerId = this.customerId;
            request.folder = new ObjectAttachmentFolder();
            request.folder.listType = this.documentListType;
            request.folder.baseFolderName = this.baseFolderName;
            request.folder.folderID = 0;
            request.folder.parentFolderID = 0;
            request.folder.description = 'All';
            request.folder.location = '';
            request.folder.subFolderFormat = DocumentAttachmentFolderSubFolderFormat.None;
            return request;
        }
    }

    getSubFolderRequest(item: any): any {
        let request: any;
        if (this.type == Kind.Object) {
            request = new GetSubFoldersForObjectFolderRequest();
            request.currentUser = this.webTrackUser;
            request.currentUser.customer.customerId = this.customerId;
            request.folder = item.ObjectSubFolder;
            return request;
        } else if (this.type == Kind.Document) {
            request = new GetSubFoldersForDocumentFolderRequest();
            request.user = this.webTrackUser;
            request.user.customer.customerId = this.customerId;
            request.folder = item.DocumentSubFolder;
            return request;
        }
    }

    getAttachmentUploadRequest(file: any): any {
        const attachmentToUpload = new Attachment();
        attachmentToUpload.attachmentID = 0;
        attachmentToUpload.name = this.attachmentProperties.attachmentName ? this.attachmentProperties.attachmentName : file.name;
        attachmentToUpload.category = this.attachmentProperties.category;
        attachmentToUpload.description = this.attachmentProperties.description;
        attachmentToUpload.fileName = this.attachmentProperties.fileName ? this.attachmentProperties.fileName : file.name;
        attachmentToUpload.folderID = 0;
        attachmentToUpload.objectListTypeID = 0;
        attachmentToUpload.documentListTypeID = 0;
        attachmentToUpload.subFolderFormat = AttachmentSubFolderFormat.None;
        attachmentToUpload.location = null;
        attachmentToUpload.sourceID = this.sourceId;
        attachmentToUpload.sourceItemCode = this.sourceItemCode; // '`Serguei Tiourine';
        attachmentToUpload.data = null;
        attachmentToUpload.path = null;
        return attachmentToUpload;
    }

    getSignatureUploadRequest(file: any): any {
        const attachmentToUpload = new Attachment();
        const fileName = this.getFileNameForSignature(new Date());
        const selectedItem = this.type == Kind.Object ? this.selectedItem.ObjectSubFolder : this.selectedItem.DocumentSubFolder;
        attachmentToUpload.attachmentID = 0;
        attachmentToUpload.name = fileName.replace('.png', '');
        attachmentToUpload.category = 'Signature';
        attachmentToUpload.description = 'Signature';
        attachmentToUpload.fileName = fileName;
        attachmentToUpload.folderID = selectedItem.folderID;
        attachmentToUpload.location = selectedItem.location;
        attachmentToUpload.sourceID = this.sourceId;
        attachmentToUpload.sourceItemCode = this.sourceItemCode;
        attachmentToUpload.data = this.signOptions.value.split(',')[1];
        attachmentToUpload.path = this.resolveFilePath(attachmentToUpload);
        return attachmentToUpload;
    }

    // Request methods end

    // Helper methods start

    resolveFilePath(attachment: any): string {
        const subFolderName = this.resolveSubfolderName(attachment);
        let relativePath = '';
        const selectedItem = this.type == Kind.Object ? this.selectedItem.ObjectSubFolder : this.selectedItem.DocumentSubFolder;
        relativePath = relativePath.concat(
            selectedItem.location,
            selectedItem.baseFolderName ? '\\' + selectedItem.baseFolderName : '',
            subFolderName ? '\\' + subFolderName : '',
            '\\' + attachment.fileName
        );
        return relativePath;
    }

    resolveSubfolderName(attachment: any) {
        let subFolderName = '';
        const selectedItem = this.type == Kind.Object ? this.selectedItem.ObjectSubFolder : this.selectedItem.DocumentSubFolder;
        switch (selectedItem.subFolderFormat) {
            case ObjectAttachmentFolderSubFolderFormat.None:
                subFolderName = '';
                break;
            case ObjectAttachmentFolderSubFolderFormat.ID:
                subFolderName = attachment.sourceID.toString();
                break;
            case ObjectAttachmentFolderSubFolderFormat.Code:
                subFolderName = attachment.sourceItemCode;
                break;
            default:
                break;
        }
        return subFolderName;
    }

    getFileNameForSignature(date) {
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const year = date.getFullYear();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        const seconds = date.getSeconds();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        const strTime = 'Signature' + month + '-' + day + '-' + year + '-' + hours + '' + minutes + '' + seconds + '-' + ampm + '.png';
        return strTime;
    }

    // Helper methods end

    // API request methods start

    getSubFolderData(request: any, subscribe: (result: any) => void) {
        if (this.type == Kind.Object) {
            try {
                this.client.getSubFoldersForObjectFolder(request).subscribe(res => {
                    if (this.sourceId) {
                        this.getAttachmentList(request.folder, (attachmentsRes: any) => {
                            if (this.treeNodes.length != 0) {
                                const nodes = this.prepareDataForTree(res, attachmentsRes);
                                this.addNode(nodes);
                            } else {
                                this.treeNodes = this.prepareDataForTree(res, attachmentsRes);
                                this.epTreeView.nodes = this.treeNodes;
                            }
                        });
                    } else {
                        if (this.treeNodes.length != 0) {
                            const nodes = this.prepareDataForTree(res, null);
                            this.addNode(nodes);
                        } else {
                            this.treeNodes = this.prepareDataForTree(res, null);
                            this.epTreeView.nodes = this.treeNodes;
                        }
                    }
                    subscribe(res);
                });
            } catch (ex) {
                console.log(ex);
            }
        } else if (this.type == Kind.Document) {
            try {
                this.client.getSubFoldersForDocumentFolder(request).subscribe(res => {
                    // if (this.documentFolders.length != 0) {
                    //   this.addNode(res);
                    //   this.prepareDataForTree(res, null);
                    // }
                    // else {
                    //   this.documentFolders = res;
                    //   this.epTreeView.nodes = this.documentFolders;
                    // }

                    this.getAttachmentList(request.folder, (attachmentsRes: any) => {
                        if (this.treeNodes.length != 0) {
                            const nodes = this.prepareDataForTree(res, attachmentsRes);
                            this.addNode(nodes);
                        } else {
                            this.treeNodes = this.prepareDataForTree(res, attachmentsRes);
                            this.epTreeView.nodes = this.treeNodes;
                        }
                    });
                    // if (this.treeNodes.length != 0) {
                    //   var nodes = this.prepareDataForTree(res, []);
                    //   this.addNode(nodes);
                    // }
                    // else {
                    //   this.treeNodes = this.prepareDataForTree(res, []);;
                    //   this.epTreeView.nodes = this.treeNodes;
                    // }
                    subscribe(res);
                });
            } catch (ex) {
                console.log(ex);
            }
        }
    }

    // This method will get the data of attachmment in base64 string (byte string)
    getAttachmentData(request: any) {
        try {
            const dialog = EpDialogService.progress({ message: 'Attachment', description: 'Downloading...' });
            this.client.getAttachmentData(request).subscribe(attachmentRes => {
                console.log(attachmentRes);
                dialog.close();
                this.showAttachment(request, attachmentRes);
            });
        } catch (ex) {
            console.log(ex);
        }
    }


    getAttachmentDataForFolderSpecific(attachment: any) {
        let request: any;
        if (this.type == Kind.Object) {
            request = new GetObjectAttachmentDataRequest();
            request.folder = this.selectedItem.ObjectSubFolder;
            request.folder.subFolders = [];
            request.folder.attachments = [];
            attachment.sourceItemCode = attachment.sourceItemCode ? attachment.sourceItemCode : this.sourceItemCode;
            request.attachment = attachment;

            try {
                this.client.getObjectAttachmentData(request).subscribe(attachmentRes => {
                    this.showAttachment(attachment, attachmentRes);
                });
            } catch (ex) {
                console.log(ex);
            }
        } else if (this.type == Kind.Document) {
            request = new GetDocumentAttachmentDataRequest();
            request.folder = this.selectedItem.DocumentSubFolder;
            request.folder.subFolders = [];
            request.folder.attachments = [];
            attachment.sourceItemCode = attachment.sourceItemCode ? attachment.sourceItemCode : this.sourceItemCode;
            request.attachment = attachment;

            try {
                this.client.getDocumentAttachmentData(request).subscribe(attachmentRes => {
                    this.showAttachment(attachment, attachmentRes);
                });
            } catch (ex) {
                console.log(ex);
            }
        }
    }

    // This method will delete the attachments
    onAttachmentDelete(attachment: Attachment) {
        const dialog = EpDialogService.progress({ message: 'Attachment', description: 'Deleting...' });
        try {
            this.client.deleteAttachment(attachment).subscribe(res => {
                if (res) {
                    this.getAllAttachments(this.sourceId);

                    if (this.selectedItem) {
                        this.getSubFolderData(this.getSubFolderRequest(this.selectedItem), (result: any) => {
                            dialog.close();
                        });
                    } else {
                        dialog.close();
                    }
                }
            });
        } catch (ex) {
            console.log(ex);
            dialog.close();
        }
    }

    // This method will get the all attachemnts list
    getAllAttachments(id) {
        this.imageData = '';
        if (this.pageName == 'ContactAttachment' || this.pageName == 'OpportunityAttachment' || this.pageName == 'ProspectAttachment') {
            if (this.type == Kind.Object) {
                this.gridModel = this.getAttachmentGridModel();
                this.client.getObjectAttachments(id, this.signatureType).subscribe(res => {
                    this.allAttachments = res;
                    this.gridModel.data = res;
                });
            }
        }
    }

    success(event: any) {
        alert('Uploaded successfully');
    }

    saveAttachment(file: any, attachmentToUpload: any) {
        let request: any;
        if (this.type == Kind.Object) {
            request = new SaveObjectAttachmentRequest();
            request.folder = this.selectedItem.ObjectSubFolder;
            request.folder.subFolders = [];
            request.folder.attachments = [];
            attachmentToUpload.data = file.result.split(',')[1];
            request.attachment = attachmentToUpload;
            const dialog = EpDialogService.progress({ message: 'Attachment', description: 'Uploading...' });
            try {
                this.client.saveObjectAttachment(request).subscribe(attachmentRes => {
                    this.faService.displayToastMessage('Attachment', attachmentToUpload.fileName + ' uploaded successfully', ErrorStatus.Success);
                    dialog.close();

                    this.getSubFolderData(this.getSubFolderRequest(this.selectedItem), (result: any) => {
                    });
                    if (this.pageName == 'ContactAttachment') {
                        this.getAllAttachments(this.sourceId);
                        this.epEvent.broadcast(CustomEvents.ContactAttachment, attachmentRes.createdObject);
                    } else if (this.pageName == 'OpportunityAttachment') {
                        this.getAllAttachments(this.sourceId);
                        this.epEvent.broadcast(CustomEvents.OpportunityAttachment, attachmentRes.createdObject);
                    } else if (this.pageName == 'ProspectAttachment') {
                        this.getAllAttachments(this.sourceId);
                        this.epEvent.broadcast(CustomEvents.ProspectAttachment, attachmentRes.createdObject);
                    }
                });
            } catch (ex) {
                dialog.close();
                this.faService.displayToastMessage('Attachment', 'Please try again', ErrorStatus.Error);

            }
        } else if (this.type == Kind.Document) {
            request = new SaveDocumentAttachmentRequest();
            request.folder = this.selectedItem.DocumentSubFolder;
            request.folder.subFolders = [];
            request.folder.attachments = [];
            attachmentToUpload.data = file.result.split(',')[1];
            request.attachment = attachmentToUpload;
            const dialog = EpDialogService.progress({ message: 'Attachment', description: 'Uploading...' });
            try {
                this.client.saveDocumentAttachment(request).subscribe(attachmentRes => {
                    dialog.close();

                    this.getSubFolderData(this.getSubFolderRequest(this.selectedItem), (result: any) => {
                        console.log(result);
                    });
                });
            } catch (ex) {
                dialog.close();
                this.faService.displayToastMessage('Attachment', 'Please try again', ErrorStatus.Error);

            }
        }
    }

    saveSignature(request: any) {
        if (this.type == Kind.Object) {
            const dialog = EpDialogService.progress({ message: 'Signature', description: 'Uploading...' });
            try {
                this.client.registerAttachment(request, this.selectedItem.ObjectSubFolder.folderID, this.signatureType, Kind.Object).subscribe(attachmentRes => {
                    dialog.close();
                    if (attachmentRes) {
                        this.faService.displayToastMessage('Signature', 'Signature uploaded successfully', ErrorStatus.Success);
                        this.showSignPanel = false;
                        this.signOptions.value = null;
                        this.getSubFolderData(this.getSubFolderRequest(this.selectedItem), (result: any) => {
                            console.log(result);
                        });
                        if (this.pageName == 'ContactAttachment') {
                            this.getAllAttachments(this.sourceId);
                            this.contactService.contactSrcId = this.sourceId;
                            this.epEvent.broadcast(CustomEvents.ContactAttachment, attachmentRes);
                        } else if (this.pageName == 'OpportunityAttachment') {
                            this.getAllAttachments(this.sourceId);
                            this.contactService.contactSrcId = this.sourceId;
                            this.epEvent.broadcast(CustomEvents.OpportunityAttachment, attachmentRes);
                        } else if (this.pageName == 'ProspectAttachment') {
                            this.getAllAttachments(this.sourceId);
                            this.epEvent.broadcast(CustomEvents.ProspectAttachment, attachmentRes);
                        }
                    }
                });
            } catch (ex) {
                dialog.close();
                this.faService.displayToastMessage('Signature', 'Please try again', ErrorStatus.Error);
            }
        } else if (this.type == Kind.Document) {
            const dialog = EpDialogService.progress({ message: 'Signature', description: 'Uploading...' });
            try {
                this.client.registerAttachment(request, this.selectedItem.DocumentSubFolder.folderID, this.signatureType, Kind.Document).subscribe(attachmentRes => {
                    dialog.close();
                    if (attachmentRes) {
                        this.faService.displayToastMessage('Signature', 'Signature uploaded successfully', ErrorStatus.Success);
                        this.showSignPanel = false;
                        this.signOptions.value = null;
                        this.getSubFolderData(this.getSubFolderRequest(this.selectedItem), (result: any) => {
                            console.log(result);
                        });
                    }
                });
            } catch (ex) {
                dialog.close();
                this.faService.displayToastMessage('Signature', 'Please try again', ErrorStatus.Error);
            }
        }
    }

    public selectEventHandler(e: any): void {
        this.disableUpload = true;
        const that = this;
        e.files.forEach((file) => {
            this.attachmentProperties.fileName = file.name;
            const attachmentName = file.name;
            this.attachmentProperties.attachmentName = attachmentName.replace(file.extension, '');
            if (!file.validationErrors) {
                const reader = new FileReader();
                reader.onload = function (ev) {
                    that.attachmentData = ev.target;
                    that.attachmentFile = file;
                };
                reader.readAsDataURL(file.rawFile);
            }
        });
    }

    public showButton(state: FileState): boolean {
        return (state === FileState.Uploaded) ? true : false;
    }


    public showAttachment(attachemnt: any, data: string) {
        if (attachemnt.fileName.toLocaleLowerCase().includes('.png')) {
            this.imageData = 'data:image/png;base64,' + data;
            EpDialogService.custom({
                title: 'Attachment',
                component: EpbtFaImageDialogComponent,
                size: EpDialogSize.Large,
                data: this.imageData,
            });
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.jpeg')) {
            this.imageData = 'data:image/jpeg;base64,' + data;
            EpDialogService.custom({
                title: 'Attachment',
                component: EpbtFaImageDialogComponent,
                size: EpDialogSize.Large,
                data: this.imageData,
            });
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.jpg')) {
            this.imageData = 'data:image/jpg;base64,' + data;
            EpDialogService.custom({
                title: 'Attachment',
                component: EpbtFaImageDialogComponent,
                size: EpDialogSize.Large,
                data: this.imageData,
            });
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.pdf')) {
            const linkSource = 'data:application/pdf;base64,' + data;
            this.showOtherTypes(attachemnt, linkSource);
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.doc')) {
            const linkSource = 'data:application/doc;base64,' + data;
            this.showOtherTypes(attachemnt, linkSource);
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.docx')) {
            const linkSource = 'data:application/docx;base64,' + data;
            this.showOtherTypes(attachemnt, linkSource);
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.txt')) {
            const linkSource = 'data:application/txt;base64,' + data;
            this.showOtherTypes(attachemnt, linkSource);
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.xps')) {
            const linkSource = 'data:application/xps;base64,' + data;
            this.showOtherTypes(attachemnt, linkSource);
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.rtf')) {
            const linkSource = 'data:application/rtf;base64,' + data;
            this.showOtherTypes(attachemnt, linkSource);
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.xlsx')) {
            const linkSource = 'data:application/xlsx;base64,' + data;
            this.showOtherTypes(attachemnt, linkSource);
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.xps')) {
            const linkSource = 'data:application/xps;base64,' + data;
            this.showOtherTypes(attachemnt, linkSource);
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.csv')) {
            const linkSource = 'data:application/csv;base64,' + data;
            this.showOtherTypes(attachemnt, linkSource);
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.ppt')) {
            const linkSource = 'data:application/ppt;base64,' + data;
            this.showOtherTypes(attachemnt, linkSource);
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.pptx')) {
            const linkSource = 'data:application/pptx;base64,' + data;
            this.showOtherTypes(attachemnt, linkSource);
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.xml')) {
            const linkSource = 'data:application/xml;base64,' + data;
            this.showOtherTypes(attachemnt, linkSource);
        } else if (attachemnt.fileName.toLocaleLowerCase().includes('.html')) {
            const linkSource = 'data:application/html;base64,' + data;
            this.showOtherTypes(attachemnt, linkSource);
        }
    }

    // This methos will be use other than image formats
    public showOtherTypes(attachemnt: any, linkSource: any) {
        const downloadLink = document.createElement('a');
        downloadLink.target = '_blank';
        const fileName = attachemnt.fileName;
        downloadLink.download = fileName;
        downloadLink.href = linkSource;
        downloadLink.setAttribute('visibility', 'hidden');
        downloadLink.click();
    }

    saveImage(type: any) {
        console.log('saveImage');
        console.log(type);
    }

    accept(type: any) {
        console.log('accept');
        console.log(type);
    }

    saveAsJPEG(type: any) {
        console.log('saveAsJPEG');
        console.log(type);
    }

    showAttachmentPanel() {
        this.showAttachPanel = true;
        this.showSignPanel = false;
        this.imageData = '';
        this.signOptions.value = null;
        this.broadcastEvents('attachment');
    }

    showSignaturePanel() {
        this.showAttachPanel = false;
        this.showSignPanel = true;
        this.imageData = '';
        this.disableUpload = false;
        this.clearAttachmentProperties();
        this.broadcastEvents('signature');
    }

    broadcastEvents(type: string) {
        if (this.pageName == 'ContactAttachment') {
            this.epEvent.broadcast(CustomEvents.ContactAttachment, 0);
            this.showPanels(type);
        } else if (this.pageName == 'OpportunityAttachment') {
            this.epEvent.broadcast(CustomEvents.OpportunityAttachment, 0);
            this.showPanels(type);
        } else if (this.pageName == 'ProspectAttachment') {
            this.epEvent.broadcast(CustomEvents.ProspectAttachment, 0);
            this.showPanels(type);
        }
    }

    showPanels(type) {
        if (type == 'attachment') {
            this.showAttachPanel = this.displayPanel;
            this.showSignPanel = false;
        } else {
            this.showAttachPanel = false;
            this.showSignPanel = this.displayPanel;
        }
    }

    getReservedSourceID(subscribe: (res: number) => void) {
        let type = '';
        let typeId = '';
        switch (this.pageName) {
            case 'ContactAttachment': {
                type = 'CustomerContact';
                typeId = 'CustomerContactID';
                break;
            }
            case 'OpportunityAttachment': {
                type = 'Opportunity';
                typeId = 'OpportunityID';
                break;
            }
            default:
                {
                    break;
                }
        }
        this.client.getReservedDocumentID(type, typeId).subscribe(res => {
            subscribe(res);
        });
    }

    uploadAttachment() {
        if (this.validateAttachement()) {
            if (this.pageName == 'ContactAttachment' || this.pageName == 'OpportunityAttachment') {
                if (!this.sourceId || this.sourceId == 0) {
                    this.getReservedSourceID((res: number) => {
                        this.sourceId = res;
                        const attachmentToUpload = this.getAttachmentUploadRequest(this.attachmentFile);
                        this.saveAttachment(this.attachmentData, attachmentToUpload);
                        this.clearAttachmentProperties();
                    });
                } else {
                    const attachmentToUpload = this.getAttachmentUploadRequest(this.attachmentFile);
                    this.saveAttachment(this.attachmentData, attachmentToUpload);
                    this.clearAttachmentProperties();
                }
            } else {
                const attachmentToUpload = this.getAttachmentUploadRequest(this.attachmentFile);
                this.saveAttachment(this.attachmentData, attachmentToUpload);
                this.clearAttachmentProperties();
            }
            //this.clearAttachmentProperties();
            this.validate = true;
            this.specialMessage = true;
            this.showAttachPanel = false;
            this.disableUpload = false;
        }
    }

    clearAttachmentProperties() {
        this.attachmentProperties.fileName = '';
        this.attachmentProperties.attachmentName = '';
        this.attachmentProperties.description = '';
        this.attachmentProperties.category = '';
    }

    validateAttachement(): boolean {
        // if (this.selectedItem.attachments) {
        const result = this.selectedItem.attachments ? this.selectedItem.attachments.filter(x => x.fileName == this.attachmentProperties.fileName) : null;
        if (result && result.length > 0
            || this.attachmentProperties.fileName.length > 50
            || this.attachmentProperties.attachmentName.length > 50
            || this.attachmentProperties.category.length > 50
            || this.attachmentProperties.fileName.includes("*")
            || this.attachmentProperties.fileName.includes("|")) {
            if (this.attachmentProperties.fileName.includes("*")
                || this.attachmentProperties.fileName.includes("|")) {
                this.specialMessage = false;
            }
            else {
                this.validate = false;
            }
        } else {
            this.validate = true;
            this.specialMessage = true;
        }
        // } else {
        //     this.validate = true;
        //     this.specialMessage = true;
        // }
        return !this.validate || !this.specialMessage ? false : true;
    }

    uploadSignature() {
        if (this.pageName == 'ContactAttachment' || this.pageName == 'OpportunityAttachment') {
            if (!this.sourceId || this.sourceId == 0) {
                this.getReservedSourceID((res: number) => {
                    this.sourceId = res;
                    const request = this.getSignatureUploadRequest(null);
                    this.saveSignature(request);
                });
            } else {
                const request = this.getSignatureUploadRequest(null);
                this.saveSignature(request);
            }
        } else {
            const request = this.getSignatureUploadRequest(null);
            this.saveSignature(request);
        }
    }

    registerOnTouched(event: any) {
        console.log(this.signOptions.value);
        console.log(event);
    }
    onBlur() {
        console.log(this.signOptions.value);
    }

    drawText() {
        console.log(this.signOptions.value);

    }
    registerOnChange(event: any) {
        console.log(this.signOptions.value);
        console.log(event);
    }

    dialogOnClick(mode: string, template?: TemplateRef<any>) {
        EpDialogService.custom({
            message: this.signOptions.value,
        });
    }

    closeSignaturePanel() {
        this.showSignPanel = false;
        this.signOptions.value = '';
    }

    closeAttachmentPanel() {
        this.showAttachPanel = false;
        this.clearAttachmentProperties();
        this.validate = true;
        this.specialMessage = true;
    }

    onFilenameChange(fileName) {
        this.validate = true;
        this.specialMessage = true;
    }

    convertToUtc(date: Date): Date {
        const offSet = date.getTimezoneOffset();
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(),
            date.getHours(), date.getMinutes() + (-1 * offSet), date.getSeconds());
    }

    getAttachmentIcon(fileName: string): any {
        if (fileName.toLowerCase().includes('.pdf')) {
            return 'pdf';
        } else if (fileName.toLowerCase().includes('.png')) {
            return 'png';
        } else if (fileName.toLowerCase().includes('.jpg') || fileName.toLowerCase().includes('.jpeg')) {
            return 'jpg';
        } else if (fileName.toLowerCase().includes('.doc') || fileName.toLowerCase().includes('.docx')) {
            return 'doc';
        } else if (fileName.toLowerCase().includes('.xls') || fileName.toLowerCase().includes('.xlsx')) {
            return 'xls';
        } else if (fileName.toLowerCase().includes('.ppt') || fileName.toLowerCase().includes('.pptx')) {
            return 'ppt';
        } else {
            return 'none';
        }
    }

    getAttachmentList(request: any, subscribe: (attachmentsList: any) => void) {
        this.imageData = '';
        if (this.type == Kind.Object) {
            try {
                this.client.getAttachmentsForObjectFolder(request, this.sourceId).subscribe(attachmentRes => {
                    if (attachmentRes.length != 0) {
                        this.selectedItem.attachments = attachmentRes;
                    }
                    subscribe(attachmentRes);
                });
            } catch (ex) {
                console.log(ex);
            }
        } else if (this.type == Kind.Document) {
            try {
                this.client.getAttachmentsForDocumentFolder(request, this.sourceId).subscribe(attachmentRes => {
                    if (attachmentRes.length != 0) {
                        this.selectedItem.attachments = attachmentRes;
                    }
                    subscribe(attachmentRes);
                });
            } catch (ex) {
                console.log(ex);
            }
        }
    }

    prepareDataForTree(folders: any[], attachemnts: any[]): any {
        const nodes: EpbtFaAttachmentModel[] = [];
        if (folders && folders.length > 0) {
            folders.forEach(item => {
                const currentItem: EpbtFaAttachmentModel = {
                    Name: item.description, ObjectSubFolder: this.type == Kind.Object ? item : null, DocumentSubFolder: this.type == Kind.Document ? item : null, Type: 'Folder'
                };
                nodes.push(currentItem);
            });
        }
        if (attachemnts && attachemnts.length > 0) {
            attachemnts.forEach(item => {
                const currentItem: EpbtFaAttachmentModel = {
                    Name: item.name, Attachment: item, Type: 'Attachment'
                };
                nodes.push(currentItem);
            });
        }
        return nodes;
    }

    addNode(node: any) {
        try {
            switch (this.indexArray.length) {
                case 1:
                    this.treeNodes[this.indexArray[0]].AttachmentOrFolderModel = node.slice();
                    break;
                case 2:
                    this.treeNodes[this.indexArray[0]].AttachmentOrFolderModel[this.indexArray[1]].AttachmentOrFolderModel = node.slice();
                    break;
                case 3:
                    this.treeNodes[this.indexArray[0]].AttachmentOrFolderModel[this.indexArray[1]].AttachmentOrFolderModel[this.indexArray[2]].AttachmentOrFolderModel = node.slice();
                    break;
                case 4:
                    this.treeNodes[this.indexArray[0]].AttachmentOrFolderModel[this.indexArray[1]].AttachmentOrFolderModel[this.indexArray[2]].
                        AttachmentOrFolderModel[this.indexArray[3]].AttachmentOrFolderModel = node.slice();
                    break;
                case 5:
                    this.treeNodes[this.indexArray[0]].AttachmentOrFolderModel[this.indexArray[1]].AttachmentOrFolderModel[this.indexArray[2]].
                        AttachmentOrFolderModel[this.indexArray[3]].AttachmentOrFolderModel[this.indexArray[4]].AttachmentOrFolderModel = node.slice();
                    break;
                default:
                    break;
            }
            // if (this.type == Kind.Object) {
            //   this.treeNodes = this.epTreeView.nodes;
            //   this.epTreeView.nodes = this.treeNodes.slice();
            // }
            // else if (this.type == Kind.Document) {
            //   this.treeNodes = this.epTreeView.nodes;
            //   this.epTreeView.nodes = this.treeNodes.slice();
            // }
        } catch (ex) {
        }
    }


    getAttachmentGridModel(): IEpGridModel {
        const selectionOptions: IEpGridSelectionOptions = {
            selectByField: 'userData.addressCode',
            selectedKeys: [],
        };
        const model: IEpGridModel = {
            resizable: false,
            reorderable: false,
            groupable: false,
            filterable: false,
            scrollable: 'scrollable',
            rowHeight: 20,
            sortable: true,
            selectionOptions: selectionOptions,
            data: this.allAttachments,
            columns: [
                { title: 'NAME', width: 50, hidden: false, class: 'color-blue', cellTemplate: this.attachDownloadTemplate },
                { field: 'fileName', title: 'FILENAME', width: 100, hidden: false },
                { field: 'description', title: 'DESCRIPTION', width: 60, hidden: false },
                { field: 'category', title: 'CATEGORY', width: 80, hidden: false },
                { title: 'DELETE', width: 50, hidden: !this.isEditable, class: 'color-blue', cellTemplate: this.attachDeleteTemplate },

            ],
            epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
                if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
                }
            },
        };
        return model;
    }
}
